// -------------------------------------------------------------------- constants --------------------------------------------------------------------

// ***************************************************************** RulePacks *******************************************************************
const INDEX_ASSIGNMENT_USER_STACK_RULE_PACKS_SUCCESS = 'INDEX_ASSIGNMENT_USER_STACK_RULE_PACKS_SUCCESS';
const INDEX_ASSIGNMENT_POSITION_STACK_RULE_PACKS_SUCCESS = 'INDEX_ASSIGNMENT_POSITION_STACK_RULE_PACKS_SUCCESS';
const STORE_ASSIGNMENT_STACK_RULE_PACK_SUCCESS = 'STORE_ASSIGNMENT_STACK_RULE_PACK_SUCCESS';

// ----------------------------------------------------------------< action creators >----------------------------------------------------------------

// ***************************************************************** RulePacks *******************************************************************
/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _indexUserSuccess(payload) {
  return {
    type: INDEX_ASSIGNMENT_USER_STACK_RULE_PACKS_SUCCESS,
    payload: payload,
  };
}
/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _indexPositionSuccess(payload) {
  return {
    type: INDEX_ASSIGNMENT_POSITION_STACK_RULE_PACKS_SUCCESS,
    payload: payload,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _storeSuccess(payload) {
  return {
    type: STORE_ASSIGNMENT_STACK_RULE_PACK_SUCCESS,
    payload: payload.data,
  };
}

// --------------------------------------------------------------------< actions >--------------------------------------------------------------------

// ***************************************************************** RulePackRules *******************************************************************
/**
 *
 * @param {String} [component]
 * @param {Number} [id]
 * @param {Object} [params]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function index(component = 'user', id, params = {}, callback = () => {
}) {
  return (dispatch, gs, api) => {
    let routes = `positions/${id}/rule-packs`;
    if (component === 'user') {
      routes = `users/${id}/rule-packs`;
    }
    api.get(routes , {params})
      .then((r) => {
        if (component === 'user') {
          dispatch(_indexUserSuccess(r));
        } else {
          dispatch(_indexPositionSuccess(r));
        }
        callback(false, r);
      })
      .catch((e) => {
        callback(e);
      });
  };
}

/**
 *
 * @param {Object} data
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function store(data, callback = () => {
}) {
  return (dispatch, gs, api) => {
    let loader = app.loading(app.translate('routes.home.attendance.stack.packs.Adding New RulePackRule'));

    api.post('/rule-packs/assign', {data})
      .then((r) => {
        dispatch(_storeSuccess(r));
        loader.hide(() => app.message(app.translate('routes.home.attendance.stack.packs.New RulePackRule Added Successfully')));
        callback(r);
      })
      .catch((e) => {
        loader.hide(() => app.error(
          e, 'routes.home.attendance.rulePackRule', 'خطا در ارسال اطلاعات',
          app.translate('routes.home.attendance.stack.packs.Adding New RulePackRule Failed'),
        ));
      });
  };
}

/**
 *
 * @return {Function}
 */
export function emptyRulePacks() {
  return _indexUserSuccess({data: {rulePacks: []}, meta: {}});
}

// --------------------------------------------------------------------< reducer >--------------------------------------------------------------------
/**
 *
 * @param {Object} state
 * @param {{type: String, payload: Object}} action
 * @return {Object}
 */
export default function reducer(state = {
  rulePacks: [],
}, action) {
  let rulePacks;

  switch (action.type) {
    case INDEX_ASSIGNMENT_USER_STACK_RULE_PACKS_SUCCESS:
      return Object.assign({}, state, {
        rulePacks: action.payload.data && action.payload.data.user ? action.payload.data.user.rulePacks: [],
      });
    case INDEX_ASSIGNMENT_POSITION_STACK_RULE_PACKS_SUCCESS:
      return Object.assign({}, state, {
        rulePacks: action.payload.data ? action.payload.data : [],
      });
    case STORE_ASSIGNMENT_STACK_RULE_PACK_SUCCESS:
      rulePacks = app._.clone(state.rulePacks);
      rulePacks.push(action.payload);
      return Object.assign({}, state, {
        rulePacks,
      });
    default:
      return state;
  }
}
